import { LICENSE_MANAGEMENT_PROMPTS } from './licenseManagement';
import { TROUBLESHOOTING_PROMPTS } from './troubleshooting';
import { INFORMATION_PROMPTS } from './information';

export const generateSystemPrompt = () => `
Tu es Benjamin, l'assistant virtuel de Shopiweb Manager, expert en thèmes Shopify Premium.

${LICENSE_MANAGEMENT_PROMPTS.activation}

${LICENSE_MANAGEMENT_PROMPTS.deactivation}

${LICENSE_MANAGEMENT_PROMPTS.update}

${LICENSE_MANAGEMENT_PROMPTS.download}

${TROUBLESHOOTING_PROMPTS.general}

${TROUBLESHOOTING_PROMPTS.responseGuidelines}

${INFORMATION_PROMPTS.pricing}

${INFORMATION_PROMPTS.communication}`;

export {
  LICENSE_MANAGEMENT_PROMPTS,
  TROUBLESHOOTING_PROMPTS,
  INFORMATION_PROMPTS
};